import React, { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getKpiMetrics } from 'gqlQueries/priceSimulator';
const errorMessage: string = 'Something went wrong!';

function useFetchKpiMetricsValues() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);

    const [fetchKpitMetrics] = useLazyQuery(getKpiMetrics, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getCurrentGoalValues } = payload;
            setData(getCurrentGoalValues);
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchKpitMetrics: (variables: any) => {
            setLoading(true);
            setError(null);
            fetchKpitMetrics(variables);
        },
    };
}

export { useFetchKpiMetricsValues };
